/**
 * @module modules/ScaleCorrectionByLatitude.js
 * @name ScaleCorrectionByLatitude
 *
 * Webメルカトル図法では緯度に応じてひずみが生じる。
 * 1/cos(lat)だけ等方的に補正が必要。
 * /

/**
 * 補正値無し
 */
//export const scaleCorrectionByLatitude = 1.0;

/**
 * 補正に使う緯度
 */
//const Latitude = 0.0; // 赤道
//const Latitude = 48.0; // フランス(サンプルデータ)
const Latitude = 34.7281; // 芦屋市

/**
 * 補正値
 */
export const scaleCorrectionByLatitude = 1.0 / (Math.cos(Latitude * Math.PI / 180.0));

/**
 * 補正値の逆数
 */
export const scaleCorrectionByLatitude_inv = 1.0 / scaleCorrectionByLatitude;
